export default {
  getList () {
    let array = []
    for (let i = 1; i <= 8; i++) {
      array.push({text: i + ' Категория', value: i})
    }
    return array
  }
}



// WEBPACK FOOTER //
// ./src/services/CategoryService.js